// extracted by mini-css-extract-plugin
module.exports = {"vehiclesListContainer":"list-module--vehiclesListContainer--3IXSE","catalogVehicleCard":"list-module--catalogVehicleCard--1dck2","vehiclesList":"list-module--vehiclesList--C40_h"};